import {AnnouncementFragment} from '../../graphql/generated/types';

export interface HelpParams {
  help_uid?: string;
  help_page?: string;
}

export type HelpItem = Omit<AnnouncementFragment, 'createDt'>;

export enum HelpQueryType {
  Id = 'help_uid',
  Page = 'help_page',
}
